import React, { useEffect, useState } from 'react';
import { authHeaders } from '../utils/authService';

// Track maps require a login, and a plain <img src> can't send one, so the image
// is fetched with the auth header and shown from memory.
const cache = new Map();

function loadThumbnail(trackId) {
  if (!cache.has(trackId)) {
    const request = fetch(`/api/tracks/${encodeURIComponent(trackId)}/thumbnail`, { headers: authHeaders() })
      .then((res) => {
        if (!res.ok) throw new Error(`Thumbnail ${trackId}: HTTP ${res.status}`);
        return res.blob();
      })
      .then((blob) => URL.createObjectURL(blob))
      .catch((err) => {
        cache.delete(trackId); // allow a retry on the next mount
        throw err;
      });
    cache.set(trackId, request);
  }
  return cache.get(trackId);
}

export default function TrackThumbnail({ trackId, alt = '', ...imgProps }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let active = true;
    setSrc(null);
    if (trackId) {
      loadThumbnail(trackId)
        .then((url) => { if (active) setSrc(url); })
        .catch((err) => console.error(err.message));
    }
    return () => { active = false; };
  }, [trackId]);

  return src ? <img src={src} alt={alt} {...imgProps} /> : null;
}
